<template>
    <div>
        <div class="menu" ref="menu">
            <Menu :bus="bus"/>
        </div>

        <div class="main">
            <Contenuto
                :title="$t('research.title')"
                :text="$t('research.text')"
                v-bind:bgvideo="require(`@/assets/img/bannervideo.mp4`)"
                v-bind:images="[require(`@/assets/img/page/research.jpg`)]"
            >
            </Contenuto>
        </div>
        <Footer />
    </div>
</template>

<script>
import Vue from "vue";
import Contenuto from "@/components/Contenuto";
import Menu from "@/components/Menu";
import Footer from "@/components/Footer";

export default {
    name: 'research',
    components: {
        Menu,
        Contenuto,
        Footer
    },
    data() {
        return {
            bus: new Vue()
        }
    }
}
</script>

<style scoped lang="scss">
    .main {
        padding-top: 120px;
        @include media-breakpoint-up(md) {
            padding-top: 220px;
        }
    }
</style>